module.exports = __webpack_public_path__ + "static/media/WSW_login_background.c4641353.png";